import { useSelector } from "react-redux";
import "./loader.css";
const Loader = () => {
  const loader_text = useSelector((state) => state.auth.loader_text);
  const subdomain_name = useSelector((state) => state.auth.product.subdomain_name)
  return (
    <>
      <div className="loader">
        <div className="lds-ring d-none">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div>
          {
            (subdomain_name === "vidcraftai") ? (
                <img  src={`${process.env.PUBLIC_URL}/assets/images/Logo-Loader.gif`} alt="logo" />
            ) : (subdomain_name === "vidwise") ? (
                <img  src={`${process.env.PUBLIC_URL}/assets/images/vidwiseLoader.gif`}  alt="logo" />
            ) : (subdomain_name === "nicheflick") ? (
              <img  src={`${process.env.PUBLIC_URL}/assets/images/Nicheflicks-loader.png`}  alt="logo" />
            ):''
          }

          
        </div>

        {loader_text && (
          <h4
            className="text-dark p-3"
            dangerouslySetInnerHTML={{
              __html: loader_text,
            }}
          ></h4>
        )}
      </div>
    </>
  );
};

export default Loader;
